import smoothReveal from 'frontend/unpoly/javascripts/util/smooth_reveal'
import { mobileBreakpoint } from 'shared/javascripts/util/mobile_breakpoint'

up.compiler(
  '[data-scroll-to]',
  (
    element,
    {
      revealPaddingMobile,
      revealPaddingDesktop,
    }: { revealPaddingMobile: number; revealPaddingDesktop: number },
  ) => {
    element.addEventListener('click', () => {
      const revealPadding = mobileBreakpoint.matches ? revealPaddingMobile : revealPaddingDesktop
      const selector = element.getAttribute('data-scroll-to')
      if (selector) {
        void smoothReveal(selector, revealPadding)
      }
    })
  },
)
